/* eslint-disable */
/*
This module is used only to define the public categoryId of the app

https://webpack.js.org/guides/public-path/#on-the-fly
 */
__webpack_public_path__ = `${document.documentElement.dataset.publicpath}`;
